import React, { useState, useEffect } from "react";
import i18n from "i18next";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import ITContractorUploadView from "./ITContractorUploadView";
import { useSelector, useDispatch } from "react-redux";
import {
  activityType,
  ACTIVITY_GROUP,
  add,
  dateConfig,
  edit,
  SET_EMPTY as EMPTY,
} from "../../config/index";
import { getActivityGroups, getJobFamilies } from "../../redux/actions/appActions";
import { getActivityGroupByLanguage } from "../../utils/punch";
export const ITContractorUploadContainer = () => {
  const methods = useForm({
    mode: "all",
  });
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const appConfig = useSelector((state) => state.appConfig);
  const user = useSelector((state) => state.user);
  const loggedInSupervisor = user.auth.user;
  const dispatch = useDispatch();
  let activityGroupOptions = getActivityGroupByLanguage(
    i18n.language,
    ACTIVITY_GROUP
  );
  const defaultAG = [{ label: t("general.select4"), value: -1 }];
 
  // get all drop-down values from back end
  try {
    if (appConfig !== null && appConfig.activityGroups !== null) {
      activityGroupOptions = getActivityGroupByLanguage(
        i18n.language,
        appConfig.activityGroups
      );
      activityGroupOptions = defaultAG.concat(activityGroupOptions.filter(item=>item.isDetailsEnabled));
    }
  } catch (error) {
    console.warn("error in appconfig setting default", appConfig);
    activityGroupOptions = getActivityGroupByLanguage(
      i18n.language,
      ACTIVITY_GROUP
    ); // setting defaults
  }
  useEffect(() => {
    if (appConfig != null && appConfig.activityGroups == null) {
      dispatch(getActivityGroups());
    }
    if (appConfig != null && appConfig.jobFamilies == null) {
      dispatch(getJobFamilies());
    }

  }, []);

  return (
    <FormProvider {...methods}>
    <ITContractorUploadView></ITContractorUploadView>
    </FormProvider>
    
  );
};

export default ITContractorUploadContainer;
